const leases = new Map<string, number>();

export const retainRecord = (key: string): void => {
	leases.set(key, (leases.get(key) ?? 0) + 1);
};

export const releaseRecord = (key: string): boolean => {
	const remaining = (leases.get(key) ?? 1) - 1;
	if (remaining <= 0) {
		leases.delete(key);
		return true;
	}
	leases.set(key, remaining);
	return false;
};

export const recordLeaseCount = (key: string): number => leases.get(key) ?? 0;

export const resetRecordLeases = (): void => {
	leases.clear();
};
